import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=eff9b954&scoped=true"
import script from "./Publication.vue?vue&type=script&lang=ts"
export * from "./Publication.vue?vue&type=script&lang=ts"
import style0 from "./Publication.vue?vue&type=style&index=0&id=eff9b954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff9b954",
  null
  
)

export default component.exports